import moment from 'moment'

const trackingStepToStage = {
  interviewTimestamp: 'Interview',
  stepApprovedTimestamp: 'Approved',
  stepBlockedTimestamp: 'Blocked',
  stepBookedTimestamp: 'Booked',
  stepInterestedTimestamp: 'Interested',
  stepPreAccessTimestamp: 'Pre access',
  stepQuizInProgressTimestamp: 'Quiz',
  stepUninterestedTimestamp: 'Uninterested',
  stepVideoOnboardingInProgressTimestamp: 'Video onboarding',
  stepWaitingForReviewTimestamp: 'Waiting for review',
  stepOnSiteTrainingTimestamp: 'Onsite training',
  stepOnsiteMeetingTimestamp: 'Onsite meeting',
}

/**
 * Get new object with filtered pipelines
 * @param {object} pipelines unfiltered
 * @param {function} func filter
 * @return {object} pipelines filtered
 */

const filterPipelines = (pipelines, func) =>
  Object.entries(pipelines).reduce(
    (acc, [key, array]) => {
      acc[key] = array.filter(func)
      return acc
    },
    {
      uninterested: [],
      interested: [],
      booked: [],
      videoOnboarding: [],
      test: [],
      refused: [],
      onSiteTraining: [],
      preAccess: [],
      finalReview: [],
      onsiteMeeting: [],
      approved: [],
    },
  )

const formatUserTrackingData = (item, field, timezone) => {
  const cityTimezone = item.city.timezone || timezone
  return item.tracking && item.tracking[field]
    ? moment
        .tz(+item.tracking[field], cityTimezone)
        .format('DD MMM YYYY, HH:mm')
    : ''
}
const getPreviousStage = trackingData => {
  if (!trackingData) return ''
  return Object.entries(trackingData).reduce(
    (acc, [key, value]) => {
      if (
        !key.toLowerCase().includes('uninterested') &&
        !key.toLowerCase().includes('interview') &&
        Number(value) > acc.timestamp &&
        acc.trackingStep !== key
      ) {
        acc = {
          timestamp: value,
          trackingStep: key,
          stage: trackingStepToStage[key],
        }
      }
      return acc
    },
    { timestamp: 0, trackingStep: '', stage: '' },
  ).stage
}

export { filterPipelines, formatUserTrackingData, getPreviousStage }
